module.exports = {"common":{"BREADCRUMB_ROOT":"Carte cadeau"}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/127.json
// module id = 1052
// module chunks = 0